// extracted by mini-css-extract-plugin
export default {"editor":"TextStyling_editor__pXHLM","draftLeft":"TextStyling_draftLeft__EVRJB","draftRight":"TextStyling_draftRight__O9TY2","draftCenter":"TextStyling_draftCenter__L7I1m"};